export class LocalStorage {
  constructor() {
    this._isStorageAvailable = false;

    this.checkStorage();
  }

  checkStorage() {
    /* istanbul ignore next */
    if (typeof localStorage !== 'undefined') {
      try {
        localStorage.setItem('reedsy_storage_test', 'yes');
        if (localStorage.getItem('reedsy_storage_test') === 'yes') {
          localStorage.removeItem('reedsy_storage_test');
          this._isStorageAvailable = true;
        } else {
          this._isStorageAvailable = false;
        }
      } catch(e) {
        this._isStorageAvailable = false;
      }
    }
  }

  getItem(key) {
    if (!this._isStorageAvailable) {
      return null;
    }

    return localStorage.getItem(key);
  }

  removeItem(key) {
    if (!this._isStorageAvailable) {
      return;
    }

    return localStorage.removeItem(key);
  }

  setItem(key, value) {
    if (!this._isStorageAvailable) {
      return;
    }

    return localStorage.setItem(key, value);
  }
}

export default new LocalStorage();
